<template>
  <div>
    <div class="text-center">
      <ConfirmationDialog
        v-if="!prescritor"
        :disabled="loading"
        open-text="Cadastrar usuário como prescritor de receita"
        headerClass="modal-header-s"
        message-title="Confirmação"
        message-body="Deseja realmente cadastrar o usuário como prescritor de receita?"
        open-class="btn-modern btn-modern-save"
        open-left-icon="fa-check"
        @yes="execute"
      />
    </div>

    <div v-if="prescritor" class="text-center border p-3 v-success">
      <p class="m-0"><i class="fas fa-check"></i> Usuário cadastrado como prescritor.</p>
    </div>

    <div class="mt-2">
      <ErrorsMessages :errors="errors" />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "UserMemed",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      loading: false,

      prescritor: null,

      errors: [],
    };
  },

  props: {
    user: [Boolean, Object],
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      this.precritor();
    },

    async precritor() {
      try {
        let params = { user_id: this.user.id };

        const response = await api.get("/rest-home/memed/prescritor/user", {
          params,
        });

        const { prescritor } = response.data;

        if (prescritor) {
          if (prescritor.body) {
            this.prescritor = JSON.parse(prescritor.body);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let params = { user_id: this.user.id };

        const response = await api.post("/rest-home/memed/prescritor", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.retrieve();
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.errors = [];
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
</style>